<template>
  <div class="nav-mobile-wrapper" :class="{ 'nav-mobile-wrapper-show': isShow }">
    <button id="btn-mobile" :class="{ 'btn-mobile-show': isShow }" @click="handleClick()"><span></span></button>
    <ul class="nav-mobile" :class="{ 'nav-mobile-show': isShow }">
      <li v-if="!isLogin"><a href="#" @click="goToOtherRoute('0')">Login</a></li>
      <li v-if="!isLogin"><a href="#" @click="goToOtherRoute('1')">Sign Up</a></li>
      <!-- <li v-if="!isLogin"><a href="#" @click="goToOtherRoute('2')">Verify</a></li>-->
      <li v-if="isLogin"><a href="#" @click="goToOtherRoute('0')">Dashboard</a></li>
      <!-- <li v-if="isLogin"><a href="#" @click="goToOtherRoute('1')">Receive</a></li>-->
      <li v-if="isLogin"><a href="#" @click="goToOtherRoute('2-1')">Profile</a></li>
      <!-- <li v-if="isLogin"><a href="#" @click="goToOtherRoute('2-2')">FAQ</a></li> -->
      <li v-if="isLogin"><a href="#" @click="goToOtherRoute('2-3')">Logout</a></li> 
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
    };
  },
  props: ['isLogin'],
  methods: {
    goToOtherRoute(key) {
      this.isShow = false;
      this.$emit('onClickNavMobile', key);
    },
    handleClick() {
      this.isShow = !this.isShow;
    },
  },
  created() {
  },
};
</script>

<style lang="scss">
$break-small: 450px;

.nav-mobile-wrapper {
  width:100%;
  max-width: $break-small;
  height: 60px;
  margin: 0 auto;
  background:transparent;
  position:relative;
  overflow:hidden;
  display: none;
  top: 0px;
  // -webkit-transition: height 2s; /* Safari */
  // transition: height 2s;

  &.nav-mobile-wrapper-show {
    height:100%;
    background: white;
  }

  @media screen and (max-width: $break-small) {
    position: absolute;
    display: inherit;
  }
  
  #btn-mobile {
    width:30px;
    height:20px;
    border:none;
    background:transparent;
    position:absolute;
    z-index:50;
    top:20px;
    right:20px;
    cursor:pointer;
    &:focus {
      outline:none;
    }
    &:after,
    &:before,
    span {
      width:100%;
      height:4px;
      border-radius:100px;
      position:absolute;
      left:0px;
      background:#fff;
       transition: all 0.4s;
    }

    &:after,
    &:before {
      content:"";
    }

    &:after {
      top:0px;
      margin-top:0px;
     }

    &:before {
      bottom:0px;
      margin-bottom:0px;
     }

    span {
      top:50%;
      margin-top:-2px;
      transform:rotate(0deg);
      opacity:1;
     }
    
    &.btn-mobile-show {
      z-index: 9999999999;
      &:after,
      &:before,
      span {
        background:#303133;
      }
      &:after,
      &:before {
        width:50%;
      }
      
      span {
        transform:rotate(180deg);
      }
      
      &:after {
        transform :rotate(45deg)translate(15px,-10px)
      }
      
      &:before {
        transform :rotate(-45deg)translate(15px,10px)
      }
    }
  }
  
  ul.nav-mobile {
    width:100%;
    // max-height:0px;
    overflow:hidden;
    height:0px;
    padding:0px;
    background: 'transparent';
    transition:background 0.3s, 0.3s max-height 0.6s;
    // -webkit-transition: background-color 2s ease-out;
    // -moz-transition: background-color 2s ease-out;
    // -o-transition: background-color 2s ease-out;
    // transition: background-color 2s ease-out;
    display:flex;
    justify-content :start;
    align-items:center;
    flex-flow:column;
    position:absolute;
    left:0;
    top:0;
    margin: 0px;
    padding-top: 60px;
    
    li {
      opacity :0;
      display:block;
      width:100%;
      text-align:center;
      padding:25px 0px;
      
      a {
        display:block;
        color:#161719;
        font-weight:400;
        text-decoration:none;
        font-size:1.7em;

        &:active,
        &:hover {
          color: #409EFF;
        }
      }

      
      
    }
    
    @for $i from 1 through 5 {
      $value: $i * 1;
      $from : $i / 1;
      $delay : 0.1 * $from;
      li:nth-of-type(#{$value}) {
         animation: bumble-off 0s+$delay ease-in ;
      }
    }
    
    &.nav-mobile-show {
      background:#fff;
      z-index: 999999998;
      transition: background 0.5s;
      height:100%;
      li {
          opacity:1;
          padding:25px;
        } 
       @for $i from 1 through 5 {
           $value: $i * 1;
          $from : $i / 1;
          $delay : -0.15 * $from;
          li:nth-of-type(#{$value}) {
          animation: bumble .9s+$delay ease-in-out ;
          }
      }
    }
  }

}

@keyframes bumble{
  0%{
    transform:translateY(-200px);
    opacity: 0.5;
    padding: 25px 0px;
   }
  
 
  30%{
    transform:translateY(0px);
    opacity: 1;
    padding: 60px 0px;
   }
   
  60%{
    opacity:1;
    padding: 15px 0px;
   }
  
  65%{
    opacity:1;
    padding: 15px 0px;
  }
  
   
  85%{
    opacity:1;
    padding: 25px 0px;
  }
  
 
  100% {
    opacity:1;
    padding: 25px 0px;
   }
}
@keyframes bumble-off{
  0% {
    opacity:1;
    padding:30px 0px;
  }
  
  80% {
    opacity:0;
    padding:15px 0px;
    transform:translateY(-300px);
  }
}
 
</style>



// WEBPACK FOOTER //
// NavMobile.vue?31f17b1c